module.exports = __webpack_public_path__ + "img/svgArrow2.8e1e517e.svg";